import { useEffect, useState } from "react";

import { AddMoreButton, SectionTitle } from "@components";
import NewSpouse from "./NewSpouse";
import Spouse from "./Spouse";

import { SpouseType } from "@type/HRM/family";

interface SpousePropsType {
  spouseInfo: SpouseType[];
  changeSpouseInfo: (data: SpouseType) => void;
  removeSpouseInfo: (spouseID: number) => void;
  getFamilyInfoRequestOngoing: boolean;
  updateSpouseRequestOngoing: boolean;
  deleteSpouseRequestOngoing: boolean;
  isProfileDisabled: boolean;
  canCreateEmployee: boolean;
  canEditEmployee: boolean;
}

const Spouses = ({
  spouseInfo,
  changeSpouseInfo,
  removeSpouseInfo,
  getFamilyInfoRequestOngoing,
  updateSpouseRequestOngoing,
  deleteSpouseRequestOngoing,
  isProfileDisabled,
  canCreateEmployee,
  canEditEmployee,
}: SpousePropsType) => {
  const [newSpouseFormShow, setNewSpouseFormShow] = useState(false);

  const [disabledProfile, setDisabledProfile] = useState<boolean>(false);
  useEffect(() => {
    //for create
    if (
      (spouseInfo?.length === 0 || spouseInfo === null) &&
      canCreateEmployee
    ) {
      setDisabledProfile(true);
    }
    //for edit
    if (spouseInfo?.length > 0 && spouseInfo !== null && canEditEmployee) {
      setDisabledProfile(true);
    }
  }, [spouseInfo, canCreateEmployee, canEditEmployee]);

  return (
    <div className="d-flex flex-column gap-8 mb-10">
      <SectionTitle
        label="EMPLOYEE.FAMILY_INFO.FORM.SPOUSE_INFO.HEADING"
        size="lg"
        noBorder
      />

      {spouseInfo?.map((spouse: SpouseType) => (
        <Spouse
          key={spouse.id}
          spouseInfo={spouse}
          changeSpouseInfo={changeSpouseInfo}
          removeSpouseInfo={removeSpouseInfo}
          getFamilyInfoRequestOngoing={getFamilyInfoRequestOngoing}
          updateSpouseRequestOngoing={updateSpouseRequestOngoing}
          deleteSpouseRequestOngoing={deleteSpouseRequestOngoing}
          isProfileDisabled={isProfileDisabled || !disabledProfile}
        />
      ))}

      {newSpouseFormShow ? (
        <NewSpouse
          setNewSpouseFormShow={setNewSpouseFormShow}
          changeSpouseInfo={changeSpouseInfo}
          updateSpouseRequestOngoing={updateSpouseRequestOngoing}
          isProfileDisabled={isProfileDisabled || !disabledProfile}
        />
      ) : (
        <AddMoreButton
          label="EMPLOYEE.FAMILY_INFO.FORM.SPOUSE_INFO.ADD_MORE_BUTTON"
          clickAction={() => setNewSpouseFormShow(true)}
          disabled={isProfileDisabled || !disabledProfile}
        />
      )}
    </div>
  );
};

export default Spouses;
